import { ReactNode } from 'react';
import * as Sentry from '@sentry/react';
import { ErrorScreen404 } from 'components/error-screen-404';

interface ErrorBoundaryProps {
  children: ReactNode;
}

const ErrorBoundary = (props: ErrorBoundaryProps) => {
  const { children } = props;

  return <Sentry.ErrorBoundary fallback={ErrorScreen404}>{children}</Sentry.ErrorBoundary>;
};

export { ErrorBoundary };
